import { EntityConditionImple } from "../entity/EntityConditionImple";

export class DtoConditionsPostResImple extends EntityConditionImple {}
